// extracted by mini-css-extract-plugin
export default {"select-boolean__item--true":"select-boolean_select-boolean__item--true__lES90","select-boolean__item--false":"select-boolean_select-boolean__item--false__62oMT"};